export default "__VITE_ASSET__DIBjLFEI__"